import store             from './store';
import { computed, ref } from 'vue';
import axios             from "axios";


export function changeMode ( newMode )
{


    if ( ![ 'login', 'register', 'forgottenPassword', 'resendConfirmation' ].includes( newMode ) )
    {
        return;
    }

    store.commit( 'changeMode', newMode );
}


export function clearSingleFieldErrors ( which )
{

    store.commit( 'removeError', which );
}


export function adjustHeaderConnect ()
{
    const header     = document.querySelector( '#site-header' );
    const btnLogin   = header.querySelector( '.btn-login' );
    const btnProfile = header.querySelector( '.btn-profile' );

    if ( store.getters.isAutheticated )
    {
        btnLogin.classList.remove( 'active' );
        btnProfile.classList.add( 'active' );
    } else
    {
        btnLogin.classList.add( 'active' );
        btnProfile.classList.remove( 'active' );
    }

}
